import { BaseResponseType } from '../cognito/authResponse.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { OnboardingDocsMetadata } from './docs.types';
import { EmployeeDocuments } from './employeeDocs.types';
import { DocStatus } from './docs.types';

export interface OnboardingDocsType {
  id: number;
  restaurant: RestaurantResponseType;
  name: string;
  required: boolean;
  metadata: OnboardingDocsMetadata;
  status?: DocStatus;
  remarks?: string;
}

export const DocStatusColorMap: Record<DocStatus, string> = {
  [DocStatus.PENDING]: '#FAE4E1',
  [DocStatus.SUBMITTED]: '#FFF4CC',
  [DocStatus.EDIT_REQUESTED]: '#FFF4CC',
  [DocStatus.APPROVED]: '#E9F3EE',
};
export const DocStatusTextColorMap: Record<DocStatus, string> = {
  [DocStatus.PENDING]: '#D5381D',
  [DocStatus.SUBMITTED]: '#997C47',
  [DocStatus.EDIT_REQUESTED]: '#997C47',
  [DocStatus.APPROVED]: '#1D8355',
};

export const DocStatusDisplayText: Record<DocStatus, string> = {
  [DocStatus.PENDING]: 'Pending',
  [DocStatus.SUBMITTED]: 'Submitted',
  [DocStatus.EDIT_REQUESTED]: 'Edits Requested',
  [DocStatus.APPROVED]: 'Approved',
};

export interface CreateOnboardingDocumentType extends BaseResponseType {
  data: OnboardingDocsType | null;
}

export interface GetOnboardingDocumentsResponseType extends BaseResponseType {
  data: OnboardingDocsType[] | null;
}
export interface GetOnboardingDocResponseType extends BaseResponseType {
  data: OnboardingDocsType | EmployeeDocuments | null;
}

export interface UpdateOnboardingDocumentsResponseType extends BaseResponseType {
  data: OnboardingDocsType | null;
}

export interface DeleteOnboardingDocumentResponseType extends BaseResponseType {
  data: null;
}
